/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="84.87"
        height="95.59"
        viewBox="0 0 84.87 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M17 25.5a1 1 0 1 1 1.45 1.38 23 23 0 0 0-2.45 3.1 31 31 0 0 0-3.08 5.84c-.28.69-.51 1.34-.69 1.91l-.15.49-.06.22a1.032 1.032 0 0 1-2-.51l.11-.38.13-.43c.2-.62.45-1.3.75-2a33.56 33.56 0 0 1 3.27-6.22A26.47 26.47 0 0 1 17 25.5Z"
          className="icon-fill icon-accent"/>
        <path
          fill="none"
          stroke="#ffb81c"
          d="M73.84 38.19A28.76 28.76 0 0 0 67.63 27"
          className="icon-sroke icon-accent"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="none"
          stroke="#fff"
          d="M83.63 49.87a22 22 0 0 0-27.46 0h0c-2.53-2.21-7.73-3.73-13.73-3.73s-11.19 1.51-13.72 3.73h0a22 22 0 0 0-27.46 0c0-23 18.44-41.66 41.18-41.66s41.19 18.65 41.19 41.66Z"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="none"
          stroke="#fff"
          d="M42.43 8.21c-12.22 14.86-13.7 33.73-13.72 41.65"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="none"
          stroke="#fff"
          d="M56.16 49.87c0-7.92-1.5-26.8-13.73-41.66M42.43 8.21v-7M21.63 83.96a10.38 10.38 0 0 0 20.76 0V46.14"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
      </svg>

    );
  }
}

Icon.displayName = 'UmbrellaIcon';

export default Icon;
